import type { TimeRange } from '../../services/analyticsService'
import { TIME_RANGE_LABELS, TIME_RANGES } from './analyticsTypes'

interface TimeRangePickerProps {
  value: TimeRange
  onChange: (range: TimeRange) => void
  className?: string
}

export default function TimeRangePicker({ value, onChange, className = '' }: TimeRangePickerProps) {
  return (
    <div
      className={`flex gap-1 overflow-x-auto rounded-2xl border border-white/10 bg-white/[0.045] p-1 custom-scrollbar ${className}`}
      role="radiogroup"
      aria-label="Time range"
    >
      {TIME_RANGES.map((range) => (
        <button
          key={range}
          type="button"
          onClick={() => onChange(range)}
          aria-pressed={value === range}
          className={`mobile-tap-target shrink-0 rounded-xl px-3.5 py-2 text-sm font-semibold transition-all ${
            value === range
              ? 'bg-white text-gray-950 shadow-lg shadow-white/10'
              : 'text-gray-400 hover:bg-white/10 hover:text-white'
          }`}
        >
          {TIME_RANGE_LABELS[range]}
        </button>
      ))}
    </div>
  )
}
